import React from 'react';
import { Loader2 } from 'lucide-react';

const Modal = ({ title, message, onConfirm, onCancel, isDeleting = false }) => {
  const handleConfirm = (e) => {
    e.stopPropagation();
    onConfirm();
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    onCancel();
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleCancel}
    >
      <div 
        className="bg-white p-6 rounded-lg shadow-lg w-80"
        onClick={handleModalClick}
      >
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        <p className="text-sm text-gray-700 mb-6">{message}</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={handleCancel}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition w-[8rem]"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isDeleting}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center min-w-[6rem]"
          >
            {isDeleting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Deleting...
              </>
            ) : (
              'Yes, Delete'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
